import React, {   useState } from 'react'
import {  Form, Input, App,Modal } from 'antd'
import { useJiekuanlxAddMutation } from '../../../store/DianShangYeWuApi';
import Icon from '../../../cpn/Icon';
function LoanTypeAdd(props) {
    const [open,setOpen] = useState(false)
    const{message} = App.useApp();    
    const [form] = Form.useForm(); 
    const [submit] = useJiekuanlxAddMutation();
    const [info,setInfo] = useState({       
        'jklx_qy_id': props.qy_id,
        'jklx_qy_name': props.qy_name,
        'jklx_name': '',
        'jklx_cid': props.yh_id,
        'jklx_cname': props.yh_name
    })
    
 
    return (
        <>
            <Icon type='add' onClick={() => {setOpen(true)}} />
            <Modal
                open={open}
                title='新增借款类型'
                width={800}
                onCancel={() => {setOpen(false)}} 
                onOk={() => {                    
                    submit(info).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {                            
                            message.success('新增成功')   
                            form.resetFields();  
                            setOpen(false);
                        }
                        if (res.data.Status === 'fail') {
                            message.error('新增失败：'+res.data.Message)
                        }
                    }) 
                }}            
            >
                <Form                                
                    form={form}
                    style={{width: '100%' }}
                    layout="horizonal"
                    name="form_jiekuanlx"
                    initialValues={{
                        modifier: 'public',
                    }}
                    labelCol={{ span: 5}}                                 
                >   
                    <Form.Item name="jklx_name" wrapperCol={{span:10}} required label='名称'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,jklx_name:e.target.value}))
                        }}/>
                    </Form.Item>                       
                </Form>
            </Modal>
        </>
    )
}

export default LoanTypeAdd